var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{on:{"click":_vm.fetch}},[_c('label',{staticClass:"rounded",class:{selected: _vm.isSelected},style:(("background-color: #" + _vm.hex))},[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }